import React from 'react';
import { ATMForm } from 'shared-it-appmod-ui';
import FormError from 'src/components/atoms/form-error/form-error.component';
import {
  IRequest,
  IRequestForm,
  RequestFormSchema,
  // RequestAdminFormSchema,
} from 'src/models/request.model';
import FlightRequestFormView from './flight-request-form.view';

type IProps = {
  formRef: React.RefObject<HTMLFormElement>;
  defaultValues?: IRequest;
  isEdit?: boolean;
  isPast: boolean;
  handleSubmit: (data: IRequestForm) => void;
  handlePast: (data: boolean) => void;
  handleDismiss: () => void;
};

const FlightRequestForm: React.FC<IProps> = ({
  formRef,
  defaultValues,
  isEdit = false,
  isPast = false,
  handleSubmit,
  handlePast,
  handleDismiss,
}) => {
  return (
    <ATMForm
      ref={formRef}
      mode="onChange"
      validationSchema={RequestFormSchema}
      onSubmit={handleSubmit}
      defaultValues={defaultValues}
      warning={isPast}
    >
      {(props) => {
        const { errors } = props;

        return (
          <>
            <FormError errors={errors} />
            <FlightRequestFormView
              {...props}
              isEdit={isEdit}
              handlePast={handlePast}
              handleDismiss={handleDismiss}
            />
          </>
        );
      }}
    </ATMForm>
  );
};

export default FlightRequestForm;
